export class emailVerificationStatus{
    emailId:any;
    OTP:any
}